module.exports = __webpack_public_path__ + "img/profile.38fd8477.jpg";